window.theme = window.theme || {};

/**
 * ANTI-GRAVITY: Dependency Waiter (Active Wait Pattern)
 * Ensures variable dependencies (like Lodash '_') are available before execution.
 */
function ensureDependency(depName, callback) {
    var maxAttempts = 50; // 5 seconds
    var attempts = 0;

    var check = function () {
        if (window[depName]) {
            callback(window[depName]);
        } else {
            attempts++;
            if (attempts < maxAttempts) {
                setTimeout(check, 100);
            } else {
                console.warn('[ANTI-GRAVITY] Dependency timeout: ' + depName);
            }
        }
    };
    check();
}

ensureDependency('_', function (_) {

    // Popup newsletter
    theme.popupNewletter = (function () {
        function popupNewletter(container) {
            var $container = (this.$container = $(container));
            var sectionId = $container.attr('data-section-id');
            this.selectors = {
                popupSection: '.popupnew-' + sectionId,
                formSection: '#jsPopupNewsletter' + sectionId
            }
            this.init();
        }
        popupNewletter.prototype = _.assignIn({}, popupNewletter.prototype, {
            init: function () {
                this.showPopup();
            },
            showPopup: function () {
                var $popupNewsletter = $(this.selectors.formSection),
                    $newsletterForm = $(this.selectors.formSection).find("form"),
                    date = new Date(),
                    minutes = theme.timePopupNewsletter;
                minutesdelay = $popupNewsletter.attr('data-delay');
                if ($popupNewsletter.length === 1) {
                    date.setTime(date.getTime() + (minutes * 60 * 1000));
                    var setCookies = function () {
                        $.cookie('cookiesNewsletter', 'disabled', { expires: date, path: '/' });
                    };
                    if ($.cookie('cookiesNewsletter') !== "disabled") {
                        $(window).on('load', function () {
                            setTimeout(function () {
                                $popupNewsletter.modal('show');
                            }, minutesdelay * 1000);
                        });
                        $popupNewsletter.on('hidden.bs.modal', setCookies);
                        $newsletterForm.submit(setCookies);
                    }
                }
                if (Shopify.designMode) {
                    document.addEventListener('shopify:section:select', function (event) {
                        $(event.target).find($popupNewsletter).modal('show');
                    });
                    document.addEventListener('shopify:section:deselect', function (event) {
                        $(event.target).find($popupNewsletter).modal('hide');
                    });
                }
            }
        });

        return popupNewletter;
    })();

    // Cookie policy
    theme.CookieSection = (function () {
        function CookieSection(container) {
            var $container = (this.$container = $(container));
            var sectionId = $container.attr('data-section-id');
            this.selectors = {
                cookieID: '.cookie-' + sectionId
            }
            this.init();
        }
        CookieSection.prototype = _.assignIn({}, CookieSection.prototype, {
            init: function () {
                this.showCookie();
            },
            showCookie: function () {
                var $policy = $(this.selectors.cookieID),
                    $closeButton = $('.js-btn-ok'),
                    isOk = localStorage.getItem('localCookie') || '';
                if (isOk === '') {
                    $policy.fadeIn('slow');
                }
                $closeButton.on('click', function () {
                    localStorage.setItem('localCookie', 'accept');
                    $policy.fadeOut('slow');
                })
                if (Shopify.designMode) {
                    document.addEventListener('shopify:section:load', function () {
                        $policy.fadeOut('slow');
                    });
                    document.addEventListener('shopify:section:select', function (event) {
                        $(event.target).find($policy).fadeIn('fast');
                    });
                    document.addEventListener('shopify:section:deselect', function (event) {
                        $(event.target).find($policy).fadeOut('slow');
                    });
                }
            }
        });
        return CookieSection;
    })();

    // Coupon
    theme.CouponCode = (function () {
        function CouponCode(container) {
            var $container = (this.$container = $(container));
            var sectionId = $container.attr('data-section-id');
            this.selectors = {
                popupCoupon: '#jsCoupon-' + sectionId,
            }
            this.init();
        }
        CouponCode.prototype = _.assignIn({}, CouponCode.prototype, {
            init: function () {
                this.coupon();
            },
            coupon: function () {
                var popupCoupon = this.selectors.popupCoupon,
                    $button = $(popupCoupon).find(".js-btn-coupon"),
                    delayTime = $(popupCoupon).data('delay') || 3000,
                    isCoupon = $(popupCoupon).length === 1 ? true : false,
                    isCopied = localStorage.getItem('localCoupon') || '';
                if (isCoupon && isCopied === '') {
                    $(document).ready(function () {
                        setTimeout(function () {
                            $(popupCoupon).modal('show');
                        }, delayTime);
                    });
                    $button.on('click', function () {
                        var copyText = document.getElementById("coupon_code");
                        copyText.select();
                        document.execCommand("Copy");
                        $(popupCoupon).modal('hide');
                        theme.alert.new('Coupon code', 'Successfully copied, now you can paste code at checkout', 4000);
                        localStorage.setItem('localCoupon', 'copied');
                    })
                }
                if (Shopify.designMode) {
                    document.addEventListener('shopify:section:select', function (event) {
                        $(event.target).find($(popupCoupon)).modal('show');
                    });
                    document.addEventListener('shopify:section:deselect', function (event) {
                        $(event.target).find($(popupCoupon)).modal('hide');
                    });
                }
            }
        });

        return CouponCode
    })();

    $(document).ready(function () {
        if (window.theme && window.theme.sections) {
            window.theme.sections.register('popupnewletter', theme.popupNewletter);
            window.theme.sections.register('cookie', theme.CookieSection);
            window.theme.sections.register('promo-code', theme.CouponCode);
        }
    });

});
